<template>
  <ion-page>
    <ion-content>
      lalla
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {IonPage, IonContent} from '@ionic/vue'
export default {
  components: {IonPage,IonContent},
  name: "Goals"
}
</script>

<style scoped>

</style>